import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Her route değişiminde document.head'deki canonical link'i günceller.
 *
 * SPA olduğumuz için index.html'de static canonical koymuyoruz — yanlış
 * canonical (her sayfada aynı) Google'a kafa karıştırır. Bunun yerine
 * runtime'da JS ile her route'a doğru URL'i set ediyoruz.
 *
 * NOT: Lighthouse audit'i static HTML'i de tarar, bu yüzden runtime
 * canonical SEO skorunu kurtarmaz. Asıl çözüm SSG/SSR'dır. Ama gerçek
 * kullanıcı (Googlebot JS rendering dahil) doğru canonical'ı görür.
 */
const PUBLIC_BASE = 'https://app.zoprey.com';

export function CanonicalUpdater() {
  const location = useLocation();

  useEffect(() => {
    const url = `${PUBLIC_BASE}${location.pathname}`;
    let link = document.head.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    );
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = url;
  }, [location.pathname]);

  return null;
}
